import { axiosInstanceWebsite } from "../instance";

// --- Types ---

export interface DesignStructureRecommendedSection {
  section_type: string;
  order: number;
  reason: string;
}

export interface DesignStructureResponse {
  recommended_template_type: string;
  recommended_sections: DesignStructureRecommendedSection[];
  reasoning: string;
}

// Payload when product comes from "tus productos" (previous/internal product)
export interface DesignStructureByProductId {
  product_id: string;
  template_types?: string[];
}

// Payload when product is manual or scraped from link
export interface DesignStructureByProductInfo {
  product_name: string;
  product_description: string;
  product_images: string[];
  template_types?: string[];
}

export type DesignStructurePayload = DesignStructureByProductId | DesignStructureByProductInfo;

// --- Service ---

export const selectDesignStructure = async (
  payload: DesignStructurePayload
): Promise<DesignStructureResponse> => {
  const response = await axiosInstanceWebsite.post(
    "/websites/design-structure/select",
    payload
  );
  return response.data;
};

// --- Sales Angle Selection (AI-powered) ---

export interface SalesAngleSelectPayload {
  angles: { name: string; description: string }[];
  design_structure: DesignStructureResponse | null;
  product_name: string;
  product_description: string;
  product_images: string[];
}

export interface SalesAngleSelectResponse {
  selected_angle: string;
  reason: string;
  reasoning: string;
}

export const selectSalesAngle = async (
  payload: SalesAngleSelectPayload
): Promise<SalesAngleSelectResponse> => {
  const response = await axiosInstanceWebsite.post(
    "/websites/sales-angle/select",
    payload
  );
  return response.data;
};
